"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castCamelObject = exports.castCamelName = void 0;
const CAST_METHOD = {
    upper: String.prototype.toUpperCase,
    lower: String.prototype.toLowerCase,
};
function castCamelName(name, cast) {
    if (typeof name !== 'string') {
        return name;
    }
    return CAST_METHOD[cast].call(name[0] || '') + name.substring(1);
}
exports.castCamelName = castCamelName;
function castCamelObject(input, cast) {
    const castMethod = CAST_METHOD[cast];
    if (!castMethod) {
        return input;
    }
    if (Array.isArray(input)) {
        return input.map(value => castCamelObject(value, cast));
    }
    if (input && typeof input === 'object') {
        const casted = Object.create(null);
        for (const [key, value] of Object.entries(input)) {
            const castedKey = castCamelName(key, cast);
            casted[castedKey] = castCamelObject(value, cast);
        }
        return casted;
    }
    return input;
}
exports.castCamelObject = castCamelObject;
